import { render, staticRenderFns } from "./BiosecurityIncidents.vue?vue&type=template&id=00a20503&scoped=true"
import script from "./BiosecurityIncidents.vue?vue&type=script&lang=js"
export * from "./BiosecurityIncidents.vue?vue&type=script&lang=js"
import style0 from "./BiosecurityIncidents.vue?vue&type=style&index=0&id=00a20503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a20503",
  null
  
)

export default component.exports